import { path } from 'ramda';
export { path };
